import { defineStore } from 'pinia'
import { useApi } from '@/composables/api'

export const useActivityStore = defineStore('activity', () => {
  const { model: activityTypes, refresh: fetchActivityTypes } = useApi({
    url: 'catalog/activity_types',
    data: [],
    pick: d => d.data || [],
  })

  return {
    activityTypes,
    //
    fetchActivityTypes,
  }
})
